import { Suspense, useEffect } from 'react';
import { handleLogout } from './Service/api/configuration/localstorage';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { path } from './Utils/ScreenPath';

import Login from './Pages/Login/Login';
import LoginwithOtp from './Pages/Login/LoginwithOtp';
import Dashboard from './Pages/Dashboard/Dashboard';
import Agents from './Pages/Agents/Agents';
import Dealer from './Pages/Dealer/Dealer';
import Team from './Pages/Team/Team';
import Inventory from './Pages/Inventory/Inventory';
import Unauthorized from './Pages/Unauthorized';
import FastagRequest from './Pages/FASTagRequest/FastagRequest';
import Report from './Pages/Report/Report';
import PublicRoute from './Routes/PublicRoute';
import ProtectedRoute from './Routes/ProtectedRoute';
import AssignedInventory from './Commponent/AssignedInventory';
import DashboardAdmin from './Pages/Dashboard/DashboardAdmin';
import DistributorAdmin from './Pages/Distributor/DistributorAdmin';
import AgentsDashboard from './Pages/Dashboard/AgentsDashboard';
// import FastagActivation from './Pages/FASTagActivation/FASTagActivation';
import AgentInventory from './Pages/Inventory/AgentInventory';
import ChangePasswordPage from './Pages/ChangePassword/ChangePasswordPage';
import MasterFASTag from './Pages/MasterFASTag/MasterFASTag';
import DistributorMasterFASTag from './Pages/MasterFASTag/DistributorMasterFASTag';
import Transactions from './Pages/Transactions/Transactions';
import TransactionsN from './Pages/Transactions/TransactionsN';
import Support from './Pages/Support/Support';
import MyAgentsRequest from './Pages/Distributor/MyAgentsRequest';
import MyFastagRequest from './Pages/Agents/MyFastagRequest';
import ResetPasswordPage from './Pages/ResetPassword/ResetPasswordPage';

function App() {
  useEffect(() => {
    const channel = new BroadcastChannel('omni_fastag_session');

    channel.onmessage = (event) => {
      if (event.data.type === 'NEW_TAB_OPENED') {
        const token = localStorage.getItem("token");
        if (token) {
           handleLogout();
        }
      }
    };

    channel.postMessage({ type: 'NEW_TAB_OPENED' });

    return () => {
      channel.close();
    };
  }, []);

  return (
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* Public */}
            <Route path={path.login} element={<PublicRoute Component={Login} />} />
            <Route path={path.loginWithOtp} element={<PublicRoute Component={LoginwithOtp} />} />
            {/* Public, token-based distributor set/reset password (accessible regardless of auth) */}
            <Route path={path.resetPassword} element={<ResetPasswordPage />} />

            {/* Protected (default allowedRoles: admin, agent, distributor) */}
            <Route path={path.dashboard} element={<ProtectedRoute Component={Dashboard} allowedRoles={["distributor", "dealer"]} />} />
            <Route path={path.dashboardadmin} element={<ProtectedRoute Component={DashboardAdmin} allowedRoles={["admin"]} />} />
            <Route path={path.dashboardagent} element={<ProtectedRoute Component={AgentsDashboard} allowedRoles={["agent"]} />} />
            <Route path={path.agents} element={<ProtectedRoute Component={Agents} allowedRoles={["admin", "distributor", "agent"]} />} />
            <Route path={path.dealers} element={<ProtectedRoute Component={Dealer} allowedRoles={["distributor"]} />} />
            <Route path={path.team} element={<ProtectedRoute Component={Team} allowedRoles={["distributor", "dealer"]} />} />
            <Route path={path.distributoradmin} element={<ProtectedRoute Component={DistributorAdmin} allowedRoles={["admin"]} />} />
            <Route path={path.inventory} element={<ProtectedRoute Component={Inventory} allowedRoles={["distributor", "dealer", "agent"]} />} />
            <Route path={path.agentinventory} element={<ProtectedRoute Component={AgentInventory} allowedRoles={["agent"]} />} />
            <Route path={path.AdminInventory} element={<ProtectedRoute Component={AssignedInventory} allowedRoles={["admin"]} />} />
            <Route path={path.report} element={<ProtectedRoute Component={Report} allowedRoles={["admin"]} />} />
            <Route path={path.fastagrequest} element={<ProtectedRoute Component={FastagRequest} allowedRoles={["admin"]} />} />
            {/* <Route path={path.fastagactivation} element={<ProtectedRoute Component={FastagActivation} allowedRoles={["distributor", "dealer", "agent"]} />} /> */}
            <Route path={path.ChangepasswordPage} element={<ProtectedRoute Component={ChangePasswordPage} allowedRoles={["admin", "distributor", "dealer", "agent"]} />} />
            <Route path={path.masterFastag} element={<ProtectedRoute Component={MasterFASTag} allowedRoles={["admin"]} />} />
            <Route path={path.transactions} element={<ProtectedRoute Component={Transactions} allowedRoles={["admin"]} />} />
            <Route path={path.transactionsN} element={<ProtectedRoute Component={TransactionsN} allowedRoles={["admin", "distributor", "dealer", "agent"]} />} />
            <Route path={path.support} element={<ProtectedRoute Component={Support} allowedRoles={["admin", "distributor", "dealer", "agent"]} />} />
            <Route path={path.masterFastagDistributor} element={<ProtectedRoute Component={DistributorMasterFASTag} allowedRoles={["distributor"]} />} />
            <Route path={path.MyAgentsRequest} element={<ProtectedRoute Component={MyAgentsRequest} allowedRoles={["distributor", "dealer"]} />} />
            <Route path={path.MyFastagRequest} element={<ProtectedRoute Component={MyFastagRequest} allowedRoles={["agent"]} />} />

            {/* Unauthorized & fallback */}
            <Route path={path.unauthorized} element={<Unauthorized />} />
            <Route
              path="*"
              element={
                <ProtectedRoute
                  Component={() => {
                    const userRaw = localStorage.getItem("UserDetail") || localStorage.getItem("user");
                    const user = userRaw ? JSON.parse(userRaw) : null;
                    const role = user?.role;
                    if (role === "admin") {
                      return <Navigate to={path.dashboardadmin} />;
                    } else if (role === "distributor" || role === "dealer") {
                      return <Navigate to={path.dashboard} />;
                    } else if (role === "agent") {
                      return <Navigate to={path.dashboardagent} />;
                    } else {
                      return <Navigate to={path.login} />;
                    }
                  }}
                />
              }
            />

          </Routes>
        </Suspense>
      </BrowserRouter>
  );
}

export default App;

